import CreateWalletForm from './CreateWalletForm';

export default CreateWalletForm;
